document.addEventListener("DOMContentLoaded", function(event) {
    window.addEventListener("load", function () {
        if ( document.querySelectorAll('.quoteBox').length ) {

            const elements = document.querySelectorAll('.quoteBox');
            elements.forEach(function(element) {

                let timeline = gsap.timeline({defaults: {autoAlpha: 0, ease: "none"}});

                    timeline
                        .from(element.querySelectorAll('.content'), {x: -10, y: -20, ease:"power2.out", duration: .6})
                        .from(element.querySelectorAll('.image'), {x: 10, y: 20, ease:"power2.out", duration: .6},"<")
                    ;

                ScrollTrigger.create({
                    trigger: element,
                    animation: timeline,
                    start: "top 70%",
                    end: "bottom 70%",
                    toggleActions: "play none none none",
                    //markers: true
                });
            });
        }
    });
});
